import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Input } from 'antd';

import { articleContentType } from 'common/constants/content';

import useStyles from './style';

const Text = ({ value, onChange, autoFocus }) => {
  const { type, content, id } = value;

  const classes = useStyles();

  const [val, setVal] = useState(content);

  const handleInputChange = ev => {
    setVal(ev.target.value);
  };

  const handleInputBlur = () => {
    onChange(id, val);
  };

  useEffect(() => {
    setVal(content);
  }, [value]);

  return (
    <div className={classes.textContainer}>
      <p className={classNames(classes.text)}>
        <Input.TextArea
          className={classNames(classes.inputText, {
            [classes.titleText]: type === articleContentType.TITLE,
            [classes.subTitleText]: type === articleContentType.SUBTITLE,
            [classes.textAreaText]: type === articleContentType.TEXTAREA,
          })}
          value={val}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          placeholder={'input here'}
          autosize={true}
          autoFocus={autoFocus}
        />
      </p>
    </div>
  );
};

export default Text;
